export default "__VITE_ASSET__BJ3N_TfJ__"